const activeCart = function () {
	$("body").append(`<div id="app-stream-cart"></div>`);

	new Vue({
		el: "#app-stream-cart",
		template: `<div>
		<div class="modal fade" id="modal-live" tabindex="-1" style="margin-top: 20vh;">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<i class="icon icon-pazzo" />
						<h4 class="modal-title"><span>直播購物車</span></h4>
					</div>
					<div class="modal-body">
						<div class="position-relative mb-4">
							<div class="controls-float">
								<input v-model="ig_id" type="text" class="form-control" placeholder="請輸入InstagramID">
							</div>
						</div>
						<!--<div class="position-relative mb-4">
						  <div style="padding-right: 225px">
							  <input v-model="fb_id" type="text" class="form-control" placeholder="請輸入FacebookID">
						  </div>
						  <a @click.prevnet="postID('Facebook')" :class="{'disabled': lockbtn}" href="#" class="btn btn-outline-secondary position-absolute" style="right: 140px; top: 0;">綁訂</a>						      		
						  <a @click.prevnet="getShoppingDatas('Facebook')" href="#" class="btn btn-outline-secondary position-absolute" style="right: 0; top: 0;">取得直播商品</a>
					  </div>-->
					</div>
					<div class="modal-footer">
						<div class="col">
							<div class="btn-block">
								<a @click.prevnet="postID('Instagram')" :class="{'disabled': lockbtn}" href="#"
									class="btn btn-outlined-primary w-50 mr-2">綁定</a>
								<a @click.prevnet="getShoppingDatas('Instagram')" href="#"
									class="btn btn-outlined-primary w-50 ml-2">取得直播商品</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div :class="{'d-none': !isRunning}"
			style="position: fixed; z-index: 2999; top: 0; left:0; right:0; bottom: 0; color: white; background: rgba(0,0,0,1); font-size: 24px; text-align: center; line-height: 100vh;">
			<div style="display: inline-block; vertical-align: middle; line-height: 1;">
				<h1>處理中, 請稍後</h1>
				<h3>(請勿關閉頁面)</h3>
			</div>
		</div>
	</div>`,
		data: {
			ig_id: null,
			fb_id: null,
			selectedID: null,
			lockbtn: false,
			isRunning: false,
		},
		created: function () {
			const _this = this;
			// $('#modal-live').on('show.bs.modal', function (e) {

			// })
			// console.log($('#modal-live').length)
			// _this.getInitID();
		},
		mounted: function () {
			const _this = this;
			$("#modal-live").on("show.bs.modal", function (e) {
				_this.getInitID();
			});
			console.log($("#modal-live").length);
		},
		methods: {
			getInitID: function () {
				const _this = this;
				// ig
				$.ajax({
					url: "/api/v1/UrPlus/Account",
					type: "GET",
					dataType: "JSON",
					data: "Source=Instagram",
				})
					.done(function (res) {
						if (res.Code === 200) {
							_this.ig_id = res.Message;
						}
					})
					.fail(function () {
						console.log("error");
					});
				// fb
				$.ajax({
					url: "/api/v1/UrPlus/Account",
					type: "GET",
					dataType: "JSON",
					data: "Source=Facebook",
				})
					.done(function (res) {
						if (res.Code === 200) {
							_this.fb_id = res.Message;
						}
					})
					.fail(function () {
						console.log("error");
					});
			},
			getCurrentID: function (s) {
				if (s === "Instagram") {
					this.selectedID = this.ig_id;
				} else if (s === "Facebook") {
					this.selectedID = this.fb_id;
				}
			},
			postID: function (s) {
				const _this = this;
				this.getCurrentID(s);
				if (this.selectedID === null) {
					AlertDialog.alert("請輸入社群ID");
					return;
				}
				_this.lockbtn = true;
				$.ajax({
					url: "/api/v1/UrPlus/Account",
					type: "POST",
					dataType: "JSON",
					data: { Name: this.selectedID, Source: s },
				})
					.done(function (res) {
						if (res.Code === 200) {
							// _this.getShoppingDatas(s);
							AlertDialog.alert("帳號已綁定", function () {
								_this.lockbtn = false;
							});
						} else if (res.Code === 401) {
							AlertDialog.alert("請先登入");
						} else {
							_this.lockbtn = false;
							AlertDialog.alert("系統忙碌中");
						}
					})
					.fail(function () {
						console.log("error");
					})
					.always(function () {
						console.log("complete");
					});
			},
			getShoppingDatas: function (s) {
				const _this = this;
				this.getCurrentID(s);
				if (this.selectedID === null) {
					AlertDialog.alert("請輸入社群ID");
					return;
				}
				_this.isRunning = true;
				$.ajax({
					url: "/api/v1/UrPlus/LiveShoppingCart",
					type: "GET",
					dataType: "JSON",
					data: "Name=" + this.selectedID + "&Source=" + s,
				})
					.done(function (res) {
						if (res.Code === 200) {
							_this.checkout(res.Response.Cart, s);
						} else if (res.Code === 401) {
							AlertDialog.alert("請先登入", function () {
								location.reload();
							});
						} else {
							_this.isRunning = false;
							AlertDialog.alert("系統忙碌中");
						}
					})
					.fail(function () {
						console.log("error");
					})
					.always(function () {
						console.log("complete");
					});
			},
			checkout: function (data, s) {
				const _this = this;
				let idx = 0;
				var total = data.length;
				const datas = data;
				let itemSoldout = false;

				if (total === 0) {
					AlertDialog.alert("直播商品僅限於特定時間，商品目前已下架", function () {
						window.location.href = "/";
					});
					return;
				}

				callCart();

				function callCart() {
					$.ajax({
						url: API_URL.SHOPPING_CART,
						type: "POST",
						dataType: "JSON",
						data:
							"CustomMarketID=" +
							datas[idx].CustomMarketID +
							"&Count=" +
							datas[idx].Amount +
							"&LiveShowID=" +
							datas[idx].LiveShowID +
							"&Channel=" +
							s,
					})
						.done(function (res) {
							if (res.Code === 205) {
								itemSoldout = true;
							}
							if (idx < total - 1) {
								idx++;
								callCart();
							} else {
								if (itemSoldout) {
									AlertDialog.alert("部分商品已售完!", function () {
										window.location.href = "/checkout";
									});
								} else {
									window.location.href = "/checkout";
								}
							}
						})
						.fail(function () {
							console.log("error");
						})
						.always(function () {
							console.log("complete");
						});
				}
			},
		},
	});
};

module.exports = activeCart;
